import print from 'vue3-print-nb'
import permission from './permission'
import increase from './increase'
import money from './money'
import increasePrsent from './increase-persent'

export default app => {
  app.use(print)
  // 自定义指令
  app.directive('permission', permission)
  app.directive('increase', increase)
  app.directive('money', money)
  app.directive('increase-prsent', increasePrsent)
}
